import { Injectable } from '@angular/core';
import { environment } from "../../../environments/environment";
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
// models/user.model.ts

export interface Pivot {
  allowed_amount: number,
  remaining_amount: number
}

export interface Products {
  name: string,
  product_number: number,
  pivot: Pivot,
  cuid: string
}
export interface User {
  cuid: string;
  full_name: string;
  updated_at: string;
  username: string;
  role: string;
  products: [Products];
  remaining_takeout: number | null;
  tag_id: string;
  active_tag: boolean;
}

export interface UserResponse {
  users: User[];
}


@Injectable({
  providedIn: 'root'
})
export class AddNewUserService {

  constructor(private http: HttpClient) { }

  addCustomer(customerData: any): Observable<any> {
    console.log(customerData)
    return this.http.post(`${environment.apiUrl}/api/cabinet-users`, customerData);
  }

  getUserSummary(): Observable<UserResponse> {
    console.log("hello")
    return this.http.get<any>(`${environment.apiUrl}/api/cabinet-users`);
  }
  updateUser(row: any): Observable<any> {
    console.log("service")
    console.log(row)
    const userData = {
      'user_id': row.user_id,
      'allowed_amount': row.takeout_limit,
      'product_id': row.product_id
    }
    console.log(userData);
    return this.http.put(`${environment.apiUrl}/api/cabinet-users/${row.user_id}`, userData);
  }

  removeUser(row: any): Observable<any> {
    console.log("service")
    console.log(row)
    const userData = {
      'user_id': row.user_id,
      'allowed_amount': row.takeout_limit,
      'product_id': row.product_id
    }
    console.log(userData);
    return this.http.delete(`${environment.apiUrl}/api/cabinet-users/${row.user_id}`);
  }
}
